/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown>, weeks: NonNullable<unknown> }} Wrapped_Streak_HoursInputs */

const en_us2_wrapped_streak_hours = /** @type {(inputs: Wrapped_Streak_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} of training over the last ${i?.weeks} weeks.`)
};

const pt_br2_wrapped_streak_hours = /** @type {(inputs: Wrapped_Streak_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} de treino nas últimas ${i?.weeks} semanas.`)
};

const es_419_wrapped_streak_hours = /** @type {(inputs: Wrapped_Streak_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} de entrenamiento en las últimas ${i?.weeks} semanas.`)
};

const pt_pt2_wrapped_streak_hours = /** @type {(inputs: Wrapped_Streak_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} de treino nas últimas ${i?.weeks} semanas.`)
};

const fr_fr2_wrapped_streak_hours = /** @type {(inputs: Wrapped_Streak_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} d'entraînement sur les ${i?.weeks} dernières semaines.`)
};

const de_de2_wrapped_streak_hours = /** @type {(inputs: Wrapped_Streak_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} Training in den letzten ${i?.weeks} Wochen.`)
};

const it_it2_wrapped_streak_hours = /** @type {(inputs: Wrapped_Streak_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration} di allenamento nelle ultime ${i?.weeks} settimane.`)
};

/**
* | output |
* | --- |
* | "{duration} of training over the last {weeks} weeks." |
*
* @param {Wrapped_Streak_HoursInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_streak_hours = /** @type {((inputs: Wrapped_Streak_HoursInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Streak_HoursInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_streak_hours(inputs)
	if (locale === "es-419") return es_419_wrapped_streak_hours(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_streak_hours(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_streak_hours(inputs)
	if (locale === "de-DE") return de_de2_wrapped_streak_hours(inputs)
	if (locale === "it-IT") return it_it2_wrapped_streak_hours(inputs)
	return en_us2_wrapped_streak_hours(inputs)
});
export { wrapped_streak_hours as "wrapped.streak_hours" }